{
  "login": "Login",
  "domain": "Domain",
  "password": "Password",
  "loginBtn": "Log in",
  "without-ldap": "Without LDAP",
  "or-sign-in-with": "Or sign in with",
  "oidc": {
    "connectionError": "OIDC Provider Connection Error",
    "unknownError": "Unknown error"
  },
  "oidcCallback": {
    "title": "Authorization Error",
    "provider": "Provider",
    "closeWindow": "Close Window",
    "backToLogin": "Back to Login",
    "errors": {
      "accessDenied": "Access Denied",
      "invalidRequest": "Invalid Request",
      "unauthorizedClient": "Unauthorized Client",
      "unsupportedResponseType": "Unsupported Response Type",
      "invalidScope": "Invalid Scope",
      "serverError": "Server Error",
      "temporarilyUnavailable": "Service Temporarily Unavailable",
      "unknown": "Unknown Error"
    }
  },
  "merge": {
    "title": "User already exists",
    "description": "A user with login \"{{login}}\" already exists in the system. To merge accounts, confirm the password of the existing account.",
    "confirmButton": "Confirm and sign in",
    "orConfirmWith": "Or confirm with",
    "backToLogin": "Go to login page",
    "sessionExpired": {
      "title": "Session expired",
      "description": "Merge session data not found or the session has expired. Please sign in again."
    },
    "noMethods": {
      "title": "No confirmation methods available",
      "description": "No confirmation methods are configured for this account. Please contact the system administrator."
    },
    "error": {
      "title": "Confirmation error",
      "invalidCredentials": "Invalid login or password",
      "unknown": "An error occurred. Please try again later."
    }
  },
  "retryLdap": "Retry loading LDAP",
  "retryOidc": "Retry loading OIDC",
  "loadingMethods": "Loading sign-in methods"
}
